import { HealthClaimModeEnum } from '@/constant/E_CLAIM'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { useRecoilValue } from 'recoil'

export const SaveConfirmationModalHook = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const hasRequestedDocuments = healthClaim.hasRequestedDocuments
  const isEditMode = healthClaim.mode === HealthClaimModeEnum.EDIT
  const isReclaimMode = healthClaim.reclaim
  const getModalContent = () => {
    // For edit mode, check if there are changes
    if (isEditMode && !isReclaimMode) {
      return {
        title: 'คุณได้มีการแก้ไขข้อมูล',
        content: 'ต้องการบันทึกการแก้ไขทั้งหมดหรือไม่?',
        confirmText: 'บันทึก',
        cancelText: 'ไม่ต้องบันทึก',
      }
    }

    // For create or reclaim mode, check if documents have been requested
    if (hasRequestedDocuments) {
      return {
        title: 'ยืนยันการสร้างเคสเคลมประกัน',
        content: 'คุณได้ตรวจสอบข้อมูลและตรวจสอบเอกสารที่ขอ เพิ่มเติมเรียบร้อยแล้วหรือไม่?',
        confirmText: 'ยืนยัน',
        cancelText: 'ยกเลิก',
      }
    }

    return {
      title: 'ยืนยันการสร้างเคส',
      content: 'คุณได้ตรวจสอบข้อมูลเรียบร้อยแล้วหรือไม่?',
      confirmText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
    }
  }

  const modalContent = getModalContent()

  return {
    modalContent,
  }
}
